import React, { FunctionComponent } from 'react';
import Row from '@/components/layout/Row';
import Col from '@/components/layout/Col';
import StaticCopyCard from '@/components/layout/landingPages/cards/StaticCopyCard';
import Header from '@/components/typography/Header';
import Image from 'next/image';
import { IPrismicContentElement } from '@/pageGeneration/services/prismicApi/types';
import PrismicRichText from '@/components/design/PrismicRichText';
import { IUserTestimonialSection } from '@/pageGeneration/services/prismicApi/userTestimonials';
import LandingPageContentSection from '@/components/landingPages/LandingPageContentSection';
import UserTestimonialSection from '@/components/landingPages/UserTestimonialSection';

interface IProps {
  contentTop: IPrismicContentElement[];
  contentMiddle: IPrismicContentElement[];
  userTestimonialSection: IUserTestimonialSection;
}

const RealtimePageComponent: FunctionComponent<IProps> = ({ contentTop, contentMiddle, userTestimonialSection }) => {
  const leftCard = contentTop[0];
  const rightCard = contentTop[1];
  const body = contentMiddle[0];
  return (
    <>
      <Row className="is-flex" gutter={[30, 0]} style={{ marginBottom: 60 }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <StaticCopyCard type="secondary" title={leftCard?.title} content={leftCard?.text} />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <StaticCopyCard type="primary" title={rightCard?.title} content={rightCard?.text} />
        </Col>
      </Row>
      <LandingPageContentSection>
        <Row gutter={[30, 0]}>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <Header level={2} color="primary" strong>
              {body.title}
            </Header>
            <PrismicRichText items={body.text} />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div style={{ minHeight: 250, position: 'relative' }}>
              <Image
                alt=" "
                src={body.image.url}
                fill
                sizes="100vw"
                style={{
                  objectFit: 'cover',
                }}
              />
            </div>
          </Col>
        </Row>
      </LandingPageContentSection>
      <LandingPageContentSection>
        <Row>
          <Col span={24}>
            <UserTestimonialSection content={userTestimonialSection} />
          </Col>
        </Row>
      </LandingPageContentSection>
    </>
  );
};

export default RealtimePageComponent;
